export const OnlineCourseCategoryPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'product.onlineCourseCategory.list-view',
    UPDATE: 'product.onlineCourseCategory.list-update',
    DELETE: 'product.onlineCourseCategory.list-delete',
  },
});
